<template>
  <PageLayout :hasPadding_pageMain="false"> 
    <!-- Main Content -->
    <template #main>
      <BOverlay :show="isLoading" rounded blur="10px" opacity="0.1">
        <ChatPanel 
          ref="chatPanelComponentRef" 
          @submit="sendAi" 
          :messages="activeChat.messages" 
          :isWaitingForAIResponse="isWaitingForAIResponse"
        ></ChatPanel>
      </BOverlay>
    </template>

    <!-- Sidebar -->
    <template #sidebar>
      <PageSidebar class="chat-sidebar-container" :show-divider="false">
        <template #body>
          <div class="chat-sidebar">
            <BButton variant="info" size="sm" @click="backToOverview" style="width: 100%;">
              <i size="16" class="fa fa-chevron-left me-1"></i>
              {{ $t('Webportal.LoopAi.BackToOverview') }}
            </BButton>
            <BButton variant="success" size="sm" @click="newChat" style="width: 100%;">
              <i size="16" class="fa fa-plus me-1"></i>
              {{ $t('Webportal.LoopAi.NewChat') }}
            </BButton>
            <ChatHistoryList 
              :histories="chatSummaries" 
              :selected="activeChat.sessionId"
              @chat-selected="selectChat" 
              @delete-chat="deleteChat"
            ></ChatHistoryList>
          </div>
        </template>
      </PageSidebar>
    </template>
  </PageLayout>
</template>

<script>
import ChatPanel from '@/componentsv3/LoopAi/ChatPanel.vue';
import PageLayout from '@/componentsv3/PageLayout.vue';
import PageSidebar from '@/componentsv3/PageSidebar.vue';
import ChatHistoryList from '@/componentsv3/LoopAi/ChatHistoryList.vue';

import LoopAiService from '@/services/LoopAiService';
import dayjs from 'dayjs';

export default {
  name: 'Chat',
  components: {
    ChatPanel,
    PageLayout,
    PageSidebar,
    ChatHistoryList,
  },
  props: {
    chatSession: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      isWaitingForAIResponse: false,
      activeChat: {
        sessionId: null,
        messages: [],
      },
      chatSummaries: [],
    };
  },
  computed: {
    userDisplayName() {
      return this.$store.getters['auth/userDisplayName'];
    },
  },
  async mounted() {
    const { data } = await LoopAiService.getChatHistory(0, 20);
    this.chatSummaries = data?.summaries;

    if(this.chatSession.sessionId) {
      this.selectChat(this.chatSession.sessionId);
    } else if(this.chatSession.prompt) {
      this.sendAi(this.chatSession.prompt);
    }
  },
  methods: {
    async deleteChat(sessionId) {
      await LoopAiService.deleteChatHistory(sessionId);
      await this.getChatHistory();
    },
    async getChatHistory() {
      const { data } = await LoopAiService.getChatHistory(0, 20);
      this.chatSummaries = data?.summaries;
    },
    backToOverview() {
      this.$emit("back");
    },
    async sendAi(prompt) {
      this.isWaitingForAIResponse = true;
      const el = this.$refs.chatPanelComponentRef;
      if (el) el.scrollDown();

      this.activeChat.messages.push({
        sessionId: '',
        role: 'user',
        text: prompt,
        createdAt: dayjs(new Date()).toISOString(),
      });

      const { data, error } = await LoopAiService.sendChatRequest(this.activeChat.sessionId, prompt);

      if (error) {
        this.isWaitingForAIResponse = false;
        console.error(error);
        return;
      }

      if (data) {
        if (this.activeChat.sessionId === null) {
          this.prepareNewSession(data.sessionId, prompt);
        }
      }

      this.activeChat.messages.push({
        sessionId: '',
        role: 'assistent',
        text: data.response,
        createdAt: dayjs(new Date()).toISOString(),
      });
      this.isWaitingForAIResponse = false;
      if (el) el.scrollDown(500);
    },
    prepareNewSession(sessionId, firstMessage) {
      this.activeChat.sessionId = sessionId;
      this.chatSummaries.unshift({ sessionId, text: firstMessage });
    },
    async selectChat(sessionId) {
      this.isLoading = true;

      const { data, error } = await LoopAiService.getChat(sessionId);

      if (error) {
        console.error(error);
        this.isLoading = false;
        return;
      }

      this.activeChat = data;
      this.isLoading = false;

      const el = this.$refs.chatPanelComponentRef;
      if (!el) return;
      el.scrollDown();
    },
    newChat() {
      this.activeChat = {
        sessionId: null,
        messages: [],
      };
    },
  },
};
</script>
